<template>
  <ul class="dressup-list">
    <li
      class="dressup-item"
      v-for="item in list"
      :key="item.uuid"
      @click="selectDressup(item)"
    >
      <div class="status" v-if="item.isUse != 'NOT_OWN'">
        {{ item.isUse == 'IN_USE' ? '使用中' : '已擁有' }}
      </div>
      <img
        class="img-dressup"
        :src="item.dressupType === 'MOUNT' ? item.dressupIcon : item.dressupUrl"
        alt=""
      />
      <div class="name">{{ item.dressupName }}</div>

      <div class="validity-time" v-if="item.isUse != 'NOT_OWN'">
        {{
          item.expirationTime
            ? `可穿戴${checkRemainingDays(item.expirationTime)}天`
            : '永久有效'
        }}
      </div>
      <div class="price" v-if="item.isUse == 'NOT_OWN' && item.priceList">
        <img
          class="img-diamond"
          src="~@/assets/image/icons/diamond.png"
          alt=""
        />
        <span>{{ getMinPrice(item.priceList) }}</span>
      </div>
      <div class="describe">
        {{ item.ownConditionDesc }}
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'DressupList',
  props: {
    list: Array
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    selectDressup(item) {
      this.$emit('select-dressup', item);
    },
    checkRemainingDays(timestamp) {
      const now = new Date().getTime();
      const remainingTime = timestamp - now;
      const days = Math.ceil(remainingTime / (1000 * 60 * 60 * 24));
      if (remainingTime < 0) {
        return '';
      }
      return days;
    },
    getMinPrice(priceArrayString) {
      const priceList = JSON.parse(priceArrayString);
      const minValue = priceList.reduce((min, obj) => {
        return min.price < obj.price ? min : obj;
      }, {});
      return minValue.price + '起';
    }
  }
};
</script>
<style lang="scss" scoped>
.dressup-list {
  height: 300px;
  overflow: auto;
  @include hideScrollBar(0, 0);
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
  color: white;
  margin-left: -10px;
  .dressup-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid yellow;
    border-radius: 10px;
    width: 112px;
    padding: 24px 8px 20px;
    margin-left: 10px;
    margin-bottom: 10px;
    position: relative;
    overflow: hidden;
    height: 160px;
    line-height: 1.4;
    .status {
      padding: 4px;
      color: black;
      position: absolute;
      left: 0;
      top: 0;
      font-size: 12px;
      background: yellow;
      border-bottom-right-radius: 10px;
    }
    .img-dressup {
      width: 60px;
      margin-bottom: 4px;
    }
    .name {
      font-weight: bold;
    }
    .price {
      display: flex;
      align-items: center;
    }
    .img-diamond {
      width: 16px;
      margin-right: 2px;
    }
  }
}
</style>
